import { Role } from '@okletsplay/core';
import { Route } from 'app/enums';
import { GuardedRoute } from 'app/interfaces/route';
import { rolesGuard } from 'app/routing/guards';
import { lazyRetry } from 'app/utils';

const ManageGamePage = lazyRetry(() => import('modules/games/pages/ManageGamePage'));
const GamePage = lazyRetry(() => import('modules/games/pages/GamePage'));
const SuccessCreatedGamePage = lazyRetry(
  () => import('modules/games/pages/SuccessCreatedGamePage')
);

export const GameRoutes: GuardedRoute[] = [
  {
    name: 'Game Create',
    path: Route.Games,
    component: ManageGamePage,
    availability: [Role.User, Role.GameAdministrator],
    guards: [rolesGuard([Role.User, Role.GameAdministrator])],
  },
  {
    name: 'Game Edit',
    path: Route.EditGame,
    component: ManageGamePage,
    availability: [Role.User, Role.GameAdministrator],
    guards: [rolesGuard([Role.User, Role.GameAdministrator])],
  },
  {
    name: 'Game Details',
    path: Route.Game,
    component: GamePage,
    availability: [],
    guards: [],
  },
  {
    name: 'Game Created',
    path: Route.GameCreated,
    component: SuccessCreatedGamePage,
    availability: [Role.User, Role.GameAdministrator],
    guards: [rolesGuard([Role.User, Role.GameAdministrator])],
  },
];
